module.exports = __webpack_public_path__ + "img/Free.fedb9b37.png";